import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from "react-router-dom";
import { convertirFecha } from "../../Utils/index";
const CardContacto =
  ({
    contact,
    selectedContact
  }) => {
    const navigate = useNavigate();
    // const [editorContacto, setContacto] = useState(false);


    const sendDetallePath = (contact) => {
      navigate('/clientes/' + `${contact.id}`)
    }
    return (
      <DivRow style={{
        backgroundColor: selectedContact?.id === contact.id ? '#dddddd' : '#FFFFFF'
      }}
        onClick={() => sendDetallePath(contact)}
        key={contact.id}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
        }} >
          <Text
            selectedContact={selectedContact}
            contact={contact}>
            {contact.name} {contact.lastname}
          </Text>
          <Text
            style={{
              fontSize: '10px',
            }}
            selectedContact={selectedContact}
            contact={contact}>
            {
              contact.Observaciones && contact.Observaciones?.length > 0 ?
                <>
                  {'Último contacto ' + convertirFecha(contact.Observaciones[contact.Observaciones.length - 1].updatedAt)} </> :
                <>
                  {
                    contact.status === "Cliente" ?
                      <p style={{ color: "#58d23e", margin: "0px", fontSize: "14px" }}>Cliente</p> : "Sin Contactar"
                  }
                </>
            }
          </Text>
        </div>
      </DivRow>
    );
  };

export default CardContacto;

const Text = styled.span`
  width: -webkit-fill-available;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: ${(prop) => prop.selectedContact?.id === prop.contact.id ? '#07082c' : '#07082c'};
`;

const DivRow = styled.div`
  width: -webkit-fill-available;
  padding: 8px;
  display: flex;
  flex-direction: row;
  gap: 5px;
  height: auto;
  align-content: flex-start;
  justify-content: start;
  align-items: center;
  border-top: 1.5px solid #e1e3ea;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
  cursor: pointer;
  background-color: 'transparent';
  transition: all 0.3s ease-in-out;
  &:hover{
    box-shadow: rgba(60, 64, 67, 0.9) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
    opacity: 0.5;
    will-change: transform;
  }
  &:active{
    will-change: transform;
  }
`;
